import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "ui-card",
  style: {"background-color":"#F7F7F7"}
}
const _hoisted_2 = { class: "ui-card-body" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "ui-reserva-titulo" }, "Informe a data de check-in e check-out para verificar nossa disponibilidade", -1)
const _hoisted_4 = { class: "ui-reserva-campos-iniciais" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Buscar")
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "ui-daj-center"
}
const _hoisted_8 = { class: "ui-reserva-area" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "ui-button-content" }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 2,
  class: "ant-row"
}
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 3,
  class: "",
  style: {"padding":"10px","min-height":"750px"}
}
const _hoisted_17 = { class: "ant-row" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-lg-16 ant-col-xl-16 ui-reserva-box-informacoes" }
const _hoisted_19 = {
  style: {"font-size":"30px","font-weight":"900"},
  class: "ui-reserva-titulo"
}
const _hoisted_20 = {
  class: "custom-slick-arrow",
  style: {"left":"10px","z-index":"1"}
}
const _hoisted_21 = {
  class: "custom-slick-arrow",
  style: {"right":"10px"}
}
const _hoisted_22 = { class: "ui-ta-left" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h3", null, "Informações", -1)
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h3", null, "Políticas", -1)
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h3", null, "Cancelamento", -1)
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-lg-8 ant-col-xl-8" }
const _hoisted_30 = { class: "ui-card-right" }
const _hoisted_31 = { class: "ui-card-flut ui-sticky" }
const _hoisted_32 = { class: "ui-reserva-total-diaria" }
const _hoisted_33 = { class: "ant-row" }
const _hoisted_34 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_35 = { class: "ui-reserva-total-geral ui-mt-15" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = { class: "ui-reserva-acoes ui-mt-15" }
const _hoisted_38 = ["href"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Reservar")
], -1)
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Trocar Box")
], -1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = {
  key: 4,
  class: "ui-card"
}
const _hoisted_44 = { class: "ui-card-body" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("h2", { class: "ui-reserva-titulo" }, "Identifique-se", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("h3", { class: "ui-reserva-sub-titulo" }, "Confirme os seus dados por favor", -1)
const _hoisted_47 = { class: "ant-row" }
const _hoisted_48 = { class: "ant-col ant-col-xs-24 ant-col-lg-24 ant-col-xl-24" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Continuar")
], -1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("h2", { class: "ui-reserva-titulo" }, "Ótimo, identificamos a sua conta.", -1)
const _hoisted_52 = { class: "ui-reserva-sub-titulo" }
const _hoisted_53 = { class: "ant-row" }
const _hoisted_54 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-lg-24 ant-col-xl-24"
}
const _hoisted_55 = {
  key: 1,
  class: "ant-col ant-col-xs-24 ant-col-lg-24 ant-col-xl-24"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Continuar")
], -1)
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = { class: "ant-row" }
const _hoisted_59 = { class: "ant-col ant-col-xs-24 ant-col-lg-4 ant-col-xl-4" }
const _hoisted_60 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-lg-5 ant-col-xl-5"
}
const _hoisted_61 = {
  key: 1,
  class: "ant-col ant-col-xs-24 ant-col-lg-5 ant-col-xl-5"
}
const _hoisted_62 = { class: "ant-col ant-col-xs-24 ant-col-lg-15 ant-col-xl-15" }
const _hoisted_63 = ["disabled"]
const _hoisted_64 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_65 = { class: "ant-col ant-col-xs-24 ant-col-lg-24 ant-col-xl-24" }
const _hoisted_66 = ["disabled"]
const _hoisted_67 = { class: "ant-row" }
const _hoisted_68 = { class: "ant-col ant-col-xs-24 ant-col-lg-12 ant-col-xl-12" }
const _hoisted_69 = { class: "ant-col ant-col-xs-24 ant-col-lg-12 ant-col-xl-12" }
const _hoisted_70 = { class: "ant-row" }
const _hoisted_71 = { class: "ant-col ant-col-xs-24 ant-col-lg-4 ant-col-xl-4" }
const _hoisted_72 = { class: "ant-col ant-col-xs-24 ant-col-lg-16 ant-col-xl-16" }
const _hoisted_73 = { class: "ant-col ant-col-xs-24 ant-col-lg-4 ant-col-xl-4" }
const _hoisted_74 = { class: "ant-row" }
const _hoisted_75 = { class: "ant-col ant-col-xs-24 ant-col-lg-8 ant-col-xl-8" }
const _hoisted_76 = { class: "ant-col ant-col-xs-24 ant-col-lg-8 ant-col-xl-8" }
const _hoisted_77 = { class: "ant-col ant-col-xs-24 ant-col-lg-8 ant-col-xl-8" }
const _hoisted_78 = { class: "ui-reserva-acoes" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Voltar")
], -1)
const _hoisted_80 = [
  _hoisted_79
]
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Pagamento")
], -1)
const _hoisted_82 = [
  _hoisted_81
]
const _hoisted_83 = {
  key: 5,
  class: "",
  style: {"padding":"10px","min-height":"500px"}
}
const _hoisted_84 = { class: "ui-reserva-titulo" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("h3", { class: "ui-reserva-sub-titulo" }, "Como você deseja efetuar o pagamento?", -1)
const _hoisted_86 = { class: "ant-row" }
const _hoisted_87 = { class: "ant-col ant-col-xs-24 ant-col-lg-16 ant-col-xl-16 ui-reserva-box-informacoes" }
const _hoisted_88 = { class: "ant-col ant-col-xs-24 ant-col-lg-8 ant-col-xl-8" }
const _hoisted_89 = { class: "ui-card-right" }
const _hoisted_90 = { class: "ui-card-flut ui-sticky" }
const _hoisted_91 = { class: "ant-row" }
const _hoisted_92 = { class: "ant-col ant-col-xs-24 ant-col-lg-24 ant-col-xl-24" }
const _hoisted_93 = { class: "ui-reserva-total-geral ui-mt-15" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_95 = { class: "ui-reserva-acoes ui-mt-15" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Concluir")
], -1)
const _hoisted_97 = [
  _hoisted_96
]
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Voltar")
], -1)
const _hoisted_99 = [
  _hoisted_98
]
const _hoisted_100 = {
  key: 6,
  style: {"padding":"10px","min-height":"500px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_selecionar_data_inicial_final = _resolveComponent("selecionar-data-inicial-final")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_icone = _resolveComponent("icone")!
  const _component_right_circle_outlined = _resolveComponent("right-circle-outlined")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_carousel = _resolveComponent("a-carousel")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_campo_adicionar_diminuir_numero = _resolveComponent("campo-adicionar-diminuir-numero")!
  const _component_campo_email = _resolveComponent("campo-email")!
  const _component_campo_cpf = _resolveComponent("campo-cpf")!
  const _component_campo_cnpj = _resolveComponent("campo-cnpj")!
  const _component_combo_tipo_pessoa = _resolveComponent("combo-tipo-pessoa")!
  const _component_campo_telefone = _resolveComponent("campo-telefone")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_campo_cep = _resolveComponent("campo-cep")!
  const _component_combo_cidade = _resolveComponent("combo-cidade")!
  const _component_radio_forma_pagamento = _resolveComponent("radio-forma-pagamento")!
  const _component_a_result = _resolveComponent("a-result")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    id: "uni-reserva",
    ref: "el",
    layout: "vertical"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.appBase.carregando
      }, {
        default: _withCtx(() => [
          ((_ctx.state.passo === 1))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                style: _normalizeStyle(!_ctx.UtilitarioGeral.valorValido(_ctx.state.reservaCriacao.reserva.dataCheckIn)?'min-height:400px;':'')
              }, [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_selecionar_data_inicial_final, {
                        dataInicialSelecionada: _ctx.state.reservaCriacao.reserva.dataCheckIn,
                        "onUpdate:dataInicialSelecionada": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.reservaCriacao.reserva.dataCheckIn) = $event)),
                        dataFinalSelecionada: _ctx.state.reservaCriacao.reserva.dataCheckOut,
                        "onUpdate:dataFinalSelecionada": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.reservaCriacao.reserva.dataCheckOut) = $event)),
                        placeholder: ['CHECK-IN','CHECKOUT'],
                        onChange: _cache[2] || (_cache[2] = ($event: any) => {_ctx.state.mensagemAlerta = '';})
                      }, null, 8, ["dataInicialSelecionada", "dataFinalSelecionada"]),
                      _createElementVNode("button", {
                        class: "ui-button -primary ui-mh-32 ui-full",
                        type: "button",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.consultarDisponibilidade()))
                      }, _hoisted_6)
                    ])
                  ]),
                  (_ctx.state.mensagemAlerta)
                    ? (_openBlock(), _createBlock(_component_a_alert, {
                        key: 0,
                        message: _ctx.state.mensagemAlerta,
                        type: "warning",
                        "show-icon": ""
                      }, null, 8, ["message"]))
                    : _createCommentVNode("", true)
                ])
              ], 4))
            : _createCommentVNode("", true),
          ((_ctx.state.passo === 1 && _ctx.UtilitarioGeral.valorValido(_ctx.state.reservaCriacao.reserva.dataCheckIn) && _ctx.state.areasDisponiveis.length > 0))
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_ctx.state.mensagemAlerta)
                  ? (_openBlock(), _createBlock(_component_a_alert, {
                      key: 0,
                      message: _ctx.state.mensagemAlerta,
                      type: "warning",
                      "show-icon": ""
                    }, null, 8, ["message"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.areasDisponiveis, (area) => {
                    return (_openBlock(), _createElementBlock("button", {
                      class: _normalizeClass((area.codigo === _ctx.state.reservaCriacao.reserva.codigoArea)?'ui-button -primary ui-reserva-area-botao':'ui-button ui-reserva-area-botao'),
                      type: "button",
                      key: area.codigo,
                      onClick: ($event: any) => (_ctx.definirAreaSelecionada(area.codigo))
                    }, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", null, _toDisplayString(area.nome), 1)
                      ])
                    ], 10, _hoisted_9))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          ((_ctx.state.passo === 1 && _ctx.UtilitarioGeral.valorValido(_ctx.state.reservaCriacao.reserva.dataCheckIn) && _ctx.state.reservaCriacao.reserva.codigoArea > 0 && _ctx.UtilitarioGeral.valorValido(_ctx.state.area.mapa)))
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_ctx.state.mensagemAlerta)
                  ? (_openBlock(), _createBlock(_component_a_alert, {
                      key: 0,
                      message: _ctx.state.mensagemAlerta,
                      type: "warning",
                      "show-icon": ""
                    }, null, 8, ["message"]))
                  : _createCommentVNode("", true),
                (_ctx.state.carregaPreviaMapa)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 'img-' + _ctx.state.chaveImg,
                      id: "AreaImgMapa",
                      src: _ctx.state.area.mapa,
                      style: {"max-width":"100%","height":"auto","z-index":"9"}
                    }, null, 8, _hoisted_12))
                  : _createCommentVNode("", true),
                ((_ctx.state.area.codigo > 0 && !_ctx.state.carregaPreviaMapa))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        (_openBlock(), _createElementBlock("div", {
                          key: 'mapw' + _ctx.state.area.mapaLargura,
                          class: "parking-lot",
                          style: _normalizeStyle('width:' + _ctx.state.area.mapaLargura + 'px;height:' + _ctx.state.area.mapaAltura + 'px; background-image: url(' + _ctx.state.area.mapa + ');background-repeat: no-repeat;background-position:center;background-size: contain;z-index:10')
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.area.boxes, (box, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                              (_ctx.boxDisponivel(box))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.definirBoxSelecionado(box)),
                                    class: "parking-space ui-box-disponivel",
                                    style: _normalizeStyle('left:' + box.posicaoX + 'px;top:' + box.posicaoY + 'px;height:' + box.altura+ 'px;width:' +box.largura+ 'px;background-color:' + _ctx.state.statusBoxDisponivel.cor + ';' + box.estilo)
                                  }, [
                                    _createElementVNode("span", {
                                      class: "ui-parking-identificacao",
                                      style: _normalizeStyle('position:relative;' + box.estiloIdentificacao)
                                    }, _toDisplayString(box.identificacao), 5)
                                  ], 12, _hoisted_15))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: "parking-space ui-box-indisponivel",
                                    title: "Reservado/Indisponível",
                                    style: _normalizeStyle('left:' + box.posicaoX + 'px;top:' + box.posicaoY + 'px;height:' + box.altura+ 'px;width:' +box.largura+ 'px;background-color:' + _ctx.obterCorStatus(box) + ';' + box.estilo)
                                  }, [
                                    _createElementVNode("span", {
                                      class: "ui-parking-identificacao",
                                      style: _normalizeStyle('position:relative;' + box.estiloIdentificacao)
                                    }, _toDisplayString(box.identificacao), 5)
                                  ], 4))
                            ], 64))
                          }), 128))
                        ], 4))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          ((_ctx.state.passo === 2))
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h2", _hoisted_19, "Box: " + _toDisplayString(_ctx.state.boxSelecionado.identificacao), 1),
                      ((_ctx.state.boxSelecionado.imagens.length > 0))
                        ? (_openBlock(), _createBlock(_component_a_carousel, {
                            key: 0,
                            "dot-position": "bottom",
                            autoplay: ""
                          }, {
                            prevArrow: _withCtx(() => [
                              _createElementVNode("div", _hoisted_20, [
                                _createVNode(_component_icone, { nome: "left-circle" })
                              ])
                            ]),
                            nextArrow: _withCtx(() => [
                              _createElementVNode("div", _hoisted_21, [
                                _createVNode(_component_right_circle_outlined)
                              ])
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.boxSelecionado.imagens, (imagem) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "",
                                  key: imagem.codigo
                                }, [
                                  _createVNode(_component_a_image, {
                                    src: imagem.imagem
                                  }, null, 8, ["src"])
                                ]))
                              }), 128))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("div", {
                        class: "ui-ml-15 ui-lh-16",
                        innerHTML: _ctx.state.boxSelecionado.informacao
                      }, null, 8, _hoisted_24),
                      _hoisted_25,
                      _createElementVNode("div", {
                        class: "ui-ml-15 ui-lh-16",
                        innerHTML: _ctx.state.area.politica
                      }, null, 8, _hoisted_26),
                      _hoisted_27,
                      _createElementVNode("div", {
                        class: "ui-ml-15 ui-lh-16",
                        innerHTML: _ctx.state.area.cancelamento
                      }, null, 8, _hoisted_28)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("span", null, [
                            _createElementVNode("h4", null, "R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.state.valorDiaria,2)), 1),
                            _createTextVNode(" diária")
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _createVNode(_component_a_form_item, { label: "CHECK-IN/CHECKOUT" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_data_inicial_final, {
                                  dataInicialSelecionada: _ctx.state.reservaCriacao.reserva.dataCheckIn,
                                  "onUpdate:dataInicialSelecionada": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.reservaCriacao.reserva.dataCheckIn) = $event)),
                                  dataFinalSelecionada: _ctx.state.reservaCriacao.reserva.dataCheckOut,
                                  "onUpdate:dataFinalSelecionada": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.reservaCriacao.reserva.dataCheckOut) = $event)),
                                  placeholder: ['CHECK-IN','CHECKOUT'],
                                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.consultarDisponibilidadeBoxSelecionado()))
                                }, null, 8, ["dataInicialSelecionada", "dataFinalSelecionada"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createVNode(_component_a_divider, { class: "ui-divider-min" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Selecione o número de pessoas")
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", null, [
                          _createVNode(_component_campo_adicionar_diminuir_numero, {
                            valorMinimo: 0,
                            valor: _ctx.state.reservaCriacao.reserva.qtdePessoasInteira,
                            "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.reservaCriacao.reserva.qtdePessoasInteira) = $event)),
                            titulo: "Inteira",
                            onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.calcularValoresReserva()))
                          }, null, 8, ["valor"]),
                          _createVNode(_component_campo_adicionar_diminuir_numero, {
                            valorMinimo: 0,
                            valor: _ctx.state.reservaCriacao.reserva.qtdePessoasMeia,
                            "onUpdate:valor": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.reservaCriacao.reserva.qtdePessoasMeia) = $event)),
                            titulo: "Meia",
                            informacao: "Crianças: 6-11 Anos",
                            onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.calcularValoresReserva()))
                          }, null, 8, ["valor"]),
                          _createVNode(_component_campo_adicionar_diminuir_numero, {
                            valorMinimo: 0,
                            valor: _ctx.state.reservaCriacao.reserva.qtdePessoasIsenta,
                            "onUpdate:valor": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.reservaCriacao.reserva.qtdePessoasIsenta) = $event)),
                            titulo: "Isenta",
                            informacao: "Crianças: 0-5 Anos",
                            onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.calcularValoresReserva()))
                          }, null, 8, ["valor"])
                        ]),
                        ((_ctx.state.area.tipoControle === _ctx.ETipoControleArea.ControleEquipamento && _ctx.state.reservaCriacao.reserva.equipamentos.length > 0))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_a_divider, { class: "ui-divider-min" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Selecione os equipamentos")
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.reservaCriacao.reserva.equipamentos, (equipamento) => {
                                  return (_openBlock(), _createBlock(_component_campo_adicionar_diminuir_numero, {
                                    key: equipamento.codigo,
                                    valorMinimo: 0,
                                    valor: equipamento.quantidade,
                                    "onUpdate:valor": ($event: any) => ((equipamento.quantidade) = $event),
                                    titulo: equipamento.nome,
                                    informacao: 'R$ ' + _ctx.UtilitarioMascara.mascararValor(equipamento.valor,2) + ' /por dia',
                                    onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.calcularValoresReserva()))
                                  }, null, 8, ["valor", "onUpdate:valor", "titulo", "informacao"]))
                                }), 128))
                              ])
                            ], 64))
                          : _createCommentVNode("", true),
                        (_ctx.state.mensagemAlerta)
                          ? (_openBlock(), _createBlock(_component_a_alert, {
                              key: 1,
                              message: _ctx.state.mensagemAlerta,
                              type: "warning",
                              "show-icon": ""
                            }, null, 8, ["message"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("span", null, [
                            _createElementVNode("h4", null, "R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.state.reservaCriacao.reserva.valorTotal,2)), 1),
                            _hoisted_36,
                            _createTextVNode("Total da reserva")
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          ((_ctx.state.periodoDisponivel && _ctx.state.reservaCriacao.reserva.valorTotal > 0 && _ctx.UtilitarioGeral.valorValido(_ctx.state.reservaCriacao.reserva.dataCheckIn)))
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: _ctx.montarLinkWhatsApp(),
                                target: "_blank",
                                class: "ui-button -primary ui-mh-32 ui-full"
                              }, _hoisted_40, 8, _hoisted_38))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "ui-button ui-mh-32 ui-full",
                            type: "button",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.definePrimeiroPasso()))
                          }, _hoisted_42)
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          ((_ctx.state.passo === 3))
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  ((_ctx.state.passoIndentificacao === 1 || _ctx.state.passoIndentificacao === 3))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_45,
                        _hoisted_46,
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("div", _hoisted_48, [
                            _createVNode(_component_a_form_item, { label: "E-mail" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_email, {
                                  valor: _ctx.state.reservaCriacao.cliente.email,
                                  "onUpdate:valor": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.reservaCriacao.cliente.email) = $event)),
                                  disabled: (_ctx.state.reservaCriacao.cliente.codigo > 0)
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        ((!_ctx.state.apresentarDadosCliente && _ctx.state.passoIndentificacao === 1))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "ui-button -primary ui-mh-32 ui-full",
                              type: "button",
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.obterClienteEmail()))
                            }, _hoisted_50))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.state.passoIndentificacao === 2)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_51,
                        _createElementVNode("h3", _hoisted_52, "Agora confirme o seu " + _toDisplayString(_ctx.state.reservaCriacao.cliente.tipoPessoa === 1? 'CPF':'CNPJ') + " por favor", 1),
                        _createElementVNode("div", _hoisted_53, [
                          ((_ctx.state.reservaCriacao.cliente.tipoPessoa === 1))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                _createVNode(_component_a_form_item, { label: " " }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_cpf, {
                                      valor: _ctx.state.cpfCnpjIdentificacao,
                                      "onUpdate:valor": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.cpfCnpjIdentificacao) = $event))
                                    }, null, 8, ["valor"])
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          ((_ctx.state.reservaCriacao.cliente.tipoPessoa === 2))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                _createVNode(_component_a_form_item, { label: " " }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_cnpj, {
                                      valor: _ctx.state.cpfCnpjIdentificacao,
                                      "onUpdate:valor": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.cpfCnpjIdentificacao) = $event))
                                    }, null, 8, ["valor"])
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        ((!_ctx.state.apresentarDadosCliente && _ctx.state.passoIndentificacao === 2))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "ui-button -primary ui-mh-32 ui-full",
                              type: "button",
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.verificaIdentificaoCliente()))
                            }, _hoisted_57))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.state.apresentarDadosCliente)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createVNode(_component_a_divider, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Dados Principais")
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            _createVNode(_component_a_form_item, { label: "Tipo Pessoa" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_combo_tipo_pessoa, {
                                  valor: _ctx.state.reservaCriacao.cliente.tipoPessoa,
                                  "onUpdate:valor": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.reservaCriacao.cliente.tipoPessoa) = $event)),
                                  disabled: (_ctx.state.reservaCriacao.cliente.codigo > 0)
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          ((_ctx.state.reservaCriacao.cliente.tipoPessoa === 1))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                _createVNode(_component_a_form_item, { label: "CPF" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_cpf, {
                                      valor: _ctx.state.reservaCriacao.cliente.cpfCnpj,
                                      "onUpdate:valor": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.reservaCriacao.cliente.cpfCnpj) = $event)),
                                      disabled: (_ctx.state.reservaCriacao.cliente.codigo > 0)
                                    }, null, 8, ["valor", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          ((_ctx.state.reservaCriacao.cliente.tipoPessoa === 2))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                _createVNode(_component_a_form_item, { label: "CNPJ" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_cnpj, {
                                      onBlur: _cache[22] || (_cache[22] = ($event: any) => (_ctx.consultaCnpj())),
                                      valor: _ctx.state.reservaCriacao.cliente.cpfCnpj,
                                      "onUpdate:valor": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.reservaCriacao.cliente.cpfCnpj) = $event)),
                                      disabled: (_ctx.state.reservaCriacao.cliente.codigo > 0)
                                    }, null, 8, ["valor", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_62, [
                            _createVNode(_component_a_form_item, {
                              label: _ctx.state.reservaCriacao.cliente.tipoPessoa === 1?'Nome':'Razão Social'
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.reservaCriacao.cliente.nomeRazaoSocial) = $event)),
                                  disabled: (_ctx.state.reservaCriacao.cliente.codigo > 0)
                                }, null, 8, _hoisted_63), [
                                  [_vModelText, _ctx.state.reservaCriacao.cliente.nomeRazaoSocial]
                                ])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ])
                        ]),
                        ((_ctx.state.reservaCriacao.cliente.tipoPessoa === 2))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                              _createElementVNode("div", _hoisted_65, [
                                _createVNode(_component_a_form_item, { label: "Nome Fantasia" }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      class: "ant-input",
                                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.reservaCriacao.cliente.nomeFantasia) = $event)),
                                      disabled: (_ctx.state.reservaCriacao.cliente.codigo > 0)
                                    }, null, 8, _hoisted_66), [
                                      [_vModelText, _ctx.state.reservaCriacao.cliente.nomeFantasia]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("div", _hoisted_68, [
                            _createVNode(_component_a_form_item, { label: "Telefone" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_telefone, {
                                  valor: _ctx.state.reservaCriacao.cliente.telefone,
                                  "onUpdate:valor": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.reservaCriacao.cliente.telefone) = $event))
                                }, null, 8, ["valor"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_69, [
                            _createVNode(_component_a_form_item, {
                              label: _ctx.state.reservaCriacao.cliente.tipoPessoa === 1?'Data de Nascimento':'Data de Abertura'
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_data, {
                                  dataSelecionada: _ctx.state.reservaCriacao.cliente.dataNascimentoAbertura,
                                  "onUpdate:dataSelecionada": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.reservaCriacao.cliente.dataNascimentoAbertura) = $event))
                                }, null, 8, ["dataSelecionada"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ])
                        ]),
                        _createVNode(_component_a_divider, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Endereço")
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_70, [
                          _createElementVNode("div", _hoisted_71, [
                            _createVNode(_component_a_form_item, { label: "CEP" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_cep, {
                                  onBlur: _cache[28] || (_cache[28] = ($event: any) => (_ctx.consultaCep())),
                                  valor: _ctx.state.reservaCriacao.cliente.enderecos[0].cep,
                                  "onUpdate:valor": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.state.reservaCriacao.cliente.enderecos[0].cep) = $event))
                                }, null, 8, ["valor"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_72, [
                            _createVNode(_component_a_form_item, { label: "Endereço/Logradouro" }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state.reservaCriacao.cliente.enderecos[0].endereco) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.reservaCriacao.cliente.enderecos[0].endereco]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_73, [
                            _createVNode(_component_a_form_item, { label: "Número" }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.reservaCriacao.cliente.enderecos[0].numero) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.reservaCriacao.cliente.enderecos[0].numero]
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_74, [
                          _createElementVNode("div", _hoisted_75, [
                            _createVNode(_component_a_form_item, { label: "Complemento" }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.state.reservaCriacao.cliente.enderecos[0].complemento) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.reservaCriacao.cliente.enderecos[0].complemento]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_76, [
                            _createVNode(_component_a_form_item, { label: "Bairro" }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.state.reservaCriacao.cliente.enderecos[0].bairro) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.reservaCriacao.cliente.enderecos[0].bairro]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_77, [
                            _createVNode(_component_a_form_item, { label: "Cidade/UF" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_combo_cidade, {
                                  codigo: _ctx.state.reservaCriacao.cliente.enderecos[0].codigoCidade,
                                  "onUpdate:codigo": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.state.reservaCriacao.cliente.enderecos[0].codigoCidade) = $event))
                                }, null, 8, ["codigo"])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  ((!_ctx.state.apresentarDadosCliente && _ctx.state.mensagemAlerta))
                    ? (_openBlock(), _createBlock(_component_a_alert, {
                        key: 3,
                        message: _ctx.state.mensagemAlerta,
                        type: "warning",
                        "show-icon": ""
                      }, null, 8, ["message"]))
                    : _createCommentVNode("", true),
                  ((_ctx.state.apresentarDadosCliente && !_ctx.verificaCamposCliente()))
                    ? (_openBlock(), _createBlock(_component_a_alert, {
                        key: 4,
                        message: "Preencha todos os dados corretamente para prosseguir para o pagamento.",
                        type: "warning",
                        "show-icon": ""
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("button", {
                      class: "ui-button ui-mh-32 ui-full",
                      type: "button",
                      onClick: _cache[35] || (_cache[35] = ($event: any) => {_ctx.state.passo = 2;_ctx.state.mensagemAlerta= ''})
                    }, _hoisted_80),
                    (_ctx.state.apresentarDadosCliente && _ctx.verificaCamposCliente())
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "ui-button -primary ui-mh-32 ui-full",
                          type: "button",
                          onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.state.passo = 4))
                        }, _hoisted_82))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          ((_ctx.state.passo === 4))
            ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                _createElementVNode("h2", _hoisted_84, _toDisplayString(_ctx.state.reservaCriacao.cliente.nomeRazaoSocial) + ",", 1),
                _hoisted_85,
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("div", _hoisted_87, [
                    _createVNode(_component_radio_forma_pagamento, {
                      codigoSelecionado: _ctx.state.reservaCriacao.reserva.codigoFormaPagamento,
                      "onUpdate:codigoSelecionado": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.state.reservaCriacao.reserva.codigoFormaPagamento) = $event)),
                      valorCompra: _ctx.state.reservaCriacao.reserva.valorTotal,
                      dadosReserva: _ctx.state.reservaCriacao,
                      "onUpdate:dadosReserva": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.state.reservaCriacao) = $event)),
                      formasPagamentos: [_ctx.state.formaPagamento]
                    }, null, 8, ["codigoSelecionado", "valorCompra", "dadosReserva", "formasPagamentos"])
                  ]),
                  _createElementVNode("div", _hoisted_88, [
                    _createElementVNode("div", _hoisted_89, [
                      _createElementVNode("div", _hoisted_90, [
                        _createElementVNode("div", _hoisted_91, [
                          _createElementVNode("div", _hoisted_92, [
                            _createElementVNode("h1", null, "Box: " + _toDisplayString(_ctx.state.boxSelecionado.identificacao), 1),
                            _createVNode(_component_a_form_item, { label: "CHECK-IN/CHECKOUT" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_data_inicial_final, {
                                  dataInicialSelecionada: _ctx.state.reservaCriacao.reserva.dataCheckIn,
                                  "onUpdate:dataInicialSelecionada": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.state.reservaCriacao.reserva.dataCheckIn) = $event)),
                                  dataFinalSelecionada: _ctx.state.reservaCriacao.reserva.dataCheckOut,
                                  "onUpdate:dataFinalSelecionada": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.state.reservaCriacao.reserva.dataCheckOut) = $event)),
                                  placeholder: ['CHECK-IN','CHECKOUT'],
                                  disabled: true
                                }, null, 8, ["dataInicialSelecionada", "dataFinalSelecionada"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createVNode(_component_a_divider, { class: "ui-divider-min" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Número de pessoas")
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", null, [
                          ((_ctx.state.reservaCriacao.reserva.qtdePessoasInteira > 0))
                            ? (_openBlock(), _createBlock(_component_campo_adicionar_diminuir_numero, {
                                key: 0,
                                editavel: false,
                                valorMinimo: 0,
                                valor: _ctx.state.reservaCriacao.reserva.qtdePessoasInteira,
                                "onUpdate:valor": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.state.reservaCriacao.reserva.qtdePessoasInteira) = $event)),
                                titulo: "Inteira",
                                onChange: _cache[42] || (_cache[42] = ($event: any) => (_ctx.calcularValoresReserva()))
                              }, null, 8, ["valor"]))
                            : _createCommentVNode("", true),
                          ((_ctx.state.reservaCriacao.reserva.qtdePessoasMeia > 0))
                            ? (_openBlock(), _createBlock(_component_campo_adicionar_diminuir_numero, {
                                key: 1,
                                editavel: false,
                                valorMinimo: 0,
                                valor: _ctx.state.reservaCriacao.reserva.qtdePessoasMeia,
                                "onUpdate:valor": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.state.reservaCriacao.reserva.qtdePessoasMeia) = $event)),
                                titulo: "Meia",
                                informacao: "Crianças: 6-11 Anos",
                                onChange: _cache[44] || (_cache[44] = ($event: any) => (_ctx.calcularValoresReserva()))
                              }, null, 8, ["valor"]))
                            : _createCommentVNode("", true),
                          ((_ctx.state.reservaCriacao.reserva.qtdePessoasIsenta > 0))
                            ? (_openBlock(), _createBlock(_component_campo_adicionar_diminuir_numero, {
                                key: 2,
                                editavel: false,
                                valorMinimo: 0,
                                valor: _ctx.state.reservaCriacao.reserva.qtdePessoasIsenta,
                                "onUpdate:valor": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.state.reservaCriacao.reserva.qtdePessoasIsenta) = $event)),
                                titulo: "Isenta",
                                informacao: "Crianças: 0-5 Anos",
                                onChange: _cache[46] || (_cache[46] = ($event: any) => (_ctx.calcularValoresReserva()))
                              }, null, 8, ["valor"]))
                            : _createCommentVNode("", true)
                        ]),
                        ((_ctx.state.area.tipoControle === _ctx.ETipoControleArea.ControleEquipamento && _ctx.state.reservaCriacao.reserva.equipamentos.length > 0 && _ctx.state.incluirEquipamentos))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_a_divider, { class: "ui-divider-min" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Equipamentos")
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.reservaCriacao.reserva.equipamentos, (equipamento) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: equipamento.codigo
                                  }, [
                                    ((equipamento.quantidade > 0))
                                      ? (_openBlock(), _createBlock(_component_campo_adicionar_diminuir_numero, {
                                          key: 0,
                                          editavel: false,
                                          valorMinimo: 0,
                                          valor: equipamento.quantidade,
                                          "onUpdate:valor": ($event: any) => ((equipamento.quantidade) = $event),
                                          titulo: equipamento.nome,
                                          informacao: 'R$ ' + _ctx.UtilitarioMascara.mascararValor(equipamento.valor,2) + ' /por dia'
                                        }, null, 8, ["valor", "onUpdate:valor", "titulo", "informacao"]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 128))
                              ])
                            ], 64))
                          : _createCommentVNode("", true),
                        (_ctx.state.mensagemAlerta)
                          ? (_openBlock(), _createBlock(_component_a_alert, {
                              key: 1,
                              message: _ctx.state.mensagemAlerta,
                              type: "warning",
                              "show-icon": ""
                            }, null, 8, ["message"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_93, [
                          _createElementVNode("span", null, [
                            _createElementVNode("h4", null, "R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.state.reservaCriacao.reserva.valorTotal,2)), 1),
                            _hoisted_94,
                            _createTextVNode("Total da reserva")
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_95, [
                          ((_ctx.state.reservaCriacao.reserva.valorTotal > 0))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "ui-button -primary ui-mh-32 ui-full",
                                type: "button",
                                onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.irParaConfirmacao()))
                              }, _hoisted_97))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "ui-button ui-mh-32 ui-full",
                            type: "button",
                            onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.state.passo = 3))
                          }, _hoisted_99)
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          ((_ctx.state.passo === 5))
            ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                _createVNode(_component_a_result, {
                  status: "success",
                  title: 'Reserva: ' + _ctx.state.reservaCriacao.reserva.numeroIdentificacao + ' confirmada com sucesso!',
                  "sub-title": "Em breve você vai receber um e-mail com mais informações."
                }, null, 8, ["title"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }, 512))
}